import { render } from "./Specialities.vue?vue&type=template&id=7dc461d7"
import script from "./Specialities.vue?vue&type=script&lang=js"
export * from "./Specialities.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Specialities.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7dc461d7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7dc461d7', __exports__)) {
    api.reload('7dc461d7', __exports__)
  }
  
  module.hot.accept("./Specialities.vue?vue&type=template&id=7dc461d7", () => {
    api.rerender('7dc461d7', render)
  })

}


export default __exports__